import { HasAccess } from "@permify/react-role";
import {
  Button,
  Col,
  Empty,
  Modal,
  Popover,
  Radio,
  Row,
  Spin,
  Tag,
  Tooltip,
  message
} from "antd";
import moment from 'moment-timezone';
import { Fragment, useEffect, useState } from 'react';
import { useTranslation } from "react-i18next";
import { Link, useLocation } from 'react-router-dom';
import { timeDiff } from '../../../services/helper';
import {
  deleteReservation,
} from "../../../services/reservation";
import codes from '../../../utils/providerCodes.json';
import usePaymentMethods from '../hooks/usePaymentMethods';

const DraftReservation = ({
  draftReservations,
  fetchReservationServices,
  reservationServices,
  draftByDate,
}) => {
  const [loadingServices, setLoadingServices] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [reservationToDelete, setReservationToDelete] = useState();
  const { doFetch, paymentData } = usePaymentMethods();
  const location = useLocation();
  const { t } = useTranslation();

  useEffect(() => {
    doFetch();
  }, [doFetch]);

  const formatDate = (date) => {
    return moment(date, 'YYYY-MM-DD').format('DD-MM-YYYY');
  };

  const loadMore = (event) => {
    const direction = event.target.value;
    const _currentPage =
      direction === "next"
        ? draftReservations.currentPage + 1
        : draftReservations.currentPage - 1;
    draftReservations.changePage(_currentPage);
  };

  const showModal = (reservation) => {
    const { id, number } = reservation;
    setModalVisible(true);
    setReservationToDelete({ id, number });
  };

  const closeModal = () => {
    setModalVisible(false);
    setReservationToDelete();
  };

  const doDeleteReservation = async (reservationId) => {
    try {
      draftReservations.changeLoading(true);
      const response = await deleteReservation({
        reservation_id: reservationId,
      });

      if (response === 1) {
        message.success({
          content: `${t("reservations.byDate.draftByDate.reservation")} eliminada exitosamente`,
          style: {
            marginTop: '30vh',
            fontSize: 16,
          },
        });
        closeModal();
        draftReservations.changePage(1);
        draftReservations.changeLoading(false);
      } else {
        message.error({
          content: 'Ocurrió un error. Inténtalo de nuevo.',
          style: {
            marginTop: '30vh',
            fontSize: 16,
          },
        });
        closeModal();
        draftReservations.changeLoading(false);
      }
    } catch (err) {
      console.error('Error interno:', err);
      message.error({
        content: `Error interno: ${err}`,
        style: {
          marginTop: '30vh',
          fontSize: 16,
        },
      });
      closeModal();
      draftReservations.changeLoading(false);
    }
  };
  const getPaymentMethodName = (paymentMethods) => {
    if (paymentMethods && paymentMethods.length > 0 && paymentData.length > 0) {
      const paymentMethod = paymentData.find(payment => payment.id === paymentMethods[0]);
      return paymentMethod ? paymentMethod.name : '-';
    }

    return '-';
  }

  const checkIfPaid = (reservation) => {
    let content
    if (reservation?.payment_methods_codes?.includes(codes.mercadopagocl) || reservation?.payment_methods_codes?.includes(codes.toku)) {
      reservation.paid ? content = "Pagado" : content = "No Pagado"
    } else {
      content = "-"
    }

    return content
  }

  return (
    <Row justify='center'>
      <Col lg={22} xs={22}>
        <Spin spinning={draftReservations.isLoading}>
          <Row justify="center">
            {draftReservations.data && draftReservations.data.length > 0 ? (
              <Fragment>
                <Col
                  lg={24}
                  xs={24}
                  className="draft-wrapper mt-lg-50 mt-md-20 mt-sm-20 mt-xs-20 mb-lg-30 mb-md-20 mb-sm-20 mb-xs-20"
                >
                  <Row justify="start" className="table-header">
                    <Col lg={2}>
                      <p className="mb-5 ml-15">
                        {t("reservations.byDate.draftByDate.reservationNumber")}
                      </p>
                    </Col>
                    {draftByDate && (
                      <Fragment>
                        <Col lg={3}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.userTitle")}
                          </p>
                        </Col>
                        <Col lg={3}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.phoneTitle")}
                          </p>
                        </Col>
                        <Col lg={3}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.mailTitle")}
                          </p>
                        </Col>
                        <Col lg={3}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.webReservationTitle")}
                          </p>
                        </Col>
                      </Fragment>
                    )}
                    {!draftByDate && (
                      <Fragment>
                        <Col lg={3}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.dateTitle")}
                          </p>
                        </Col>
                        <Col lg={4}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.companyTitle")}
                          </p>
                        </Col>
                        <Col lg={2}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.branchOfficeTitle")}
                          </p>
                        </Col>
                        <Col lg={3}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.paymentMethodTitle")}
                          </p>
                        </Col>
                        <Col lg={3}>
                          <p className="text-center mb-5">
                            {t("reservations.byDate.draftByDate.paymentStateTitle")}
                          </p>
                        </Col>
                        <Col lg={2}>
                          <Popover
                            trigger="hover"
                            overlayClassName="sidebar-tooltip"
                            placement="topLeft"
                            content={
                              <p className="mb-5">
                                {t("reservations.byDate.draftByDate.attendancePopover")}
                              </p>
                            }
                          >
                            <p className="text-center mb-5">
                              <u>{t("reservations.byDate.draftByDate.attendanceTitle")}</u>
                            </p>
                          </Popover>
                        </Col>
                      </Fragment>
                    )}
                    <Col lg={!draftByDate ? 3 : 3}>
                      <p className="text-center mb-5">
                        {t("reservations.byDate.draftByDate.servicesTitle")}
                      </p>
                    </Col>
                    {draftByDate && (
                      <Col lg={3}>
                        <p className="text-center mb-5">
                          {t("reservations.byDate.draftByDate.creationTitle")}
                        </p>
                      </Col>
                    )}

                  </Row>
                  {draftReservations.data.map((reservation) => {
                    return (
                      <Row
                        className="table-body mb-lg-10 mb-md-15 mb-sm-15 mb-xs-15"
                        key={reservation.id}
                      >
                        <Col lg={2} xs={12} className="table-body__item first">
                          <p className="mobile-title text-center">
                            {t("reservations.byDate.draftByDate.reservationNumber")}
                          </p>
                          <p className="mb-0 ml-lg-15 ml-xs-0">
                            {reservation.number}&nbsp;
                            {reservation.deleted_at && (
                              <Tag color="red">eliminada</Tag>
                            )}
                          </p>
                        </Col>
                        {draftByDate && (
                          <Fragment>
                            <Col lg={3} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.userTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {reservation.user_fullname}
                              </p>
                            </Col>
                            <Col lg={3} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.phoneTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {reservation.user_phone}
                              </p>
                            </Col>
                            <Col lg={3} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.mailTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {reservation.user_email}
                              </p>
                            </Col>
                            <Col lg={3} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.webReservationTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {reservation.web_way ? "Sí" : "No"}
                              </p>
                            </Col>
                          </Fragment>
                        )}
                        {!draftByDate && (
                          <Fragment>
                            <Col lg={3} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.dateTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {formatDate(reservation.reservation_date)}
                              </p>
                            </Col>
                            <Col lg={4} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.companyTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {reservation?.business_name}
                              </p>
                            </Col>
                            <Col lg={2} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.branchOfficeTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {reservation.branch_office_name}
                              </p>
                            </Col>
                            <Col lg={3} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.paymentMethodTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {
                                  getPaymentMethodName(reservation.payment_methods)
                                }
                              </p>
                            </Col>
                            <Col lg={3} xs={12} className="table-body__item">
                              <p className="mobile-title text-center">
                                {t("reservations.byDate.draftByDate.paymentStateTitle")}
                              </p>
                              <p className="text-center mb-0">
                                {checkIfPaid(reservation)}
                              </p>
                            </Col>
                            <Col lg={2} className="table-body__item">
                              <p className="text-center mb-5">
                                {
                                  reservation?.willAttend >= 0 && reservation?.preadmittedPatients >= 0 ?
                                    reservation.willAttend + '/' + reservation.preadmittedPatients
                                    : "-"
                                }
                              </p>
                            </Col>
                          </Fragment>
                        )}
                        <Col
                          lg={3}
                          xs={12}
                          className="table-body__item"
                        >
                          <Tooltip
                            overlayClassName='see-services-tooltip'
                            trigger="click"
                            onClick={() =>
                              fetchReservationServices(reservation.id, setLoadingServices)
                            }
                            color="#FFFFFF"
                            title={
                              <Fragment>
                                <Row justify="space-between">
                                  <Col lg={12}>
                                    <p className="title mb-10">
                                      {t("reservations.byDate.draftByDate.serviceTooltip")}
                                    </p>
                                  </Col>
                                  <Col lg={6}>
                                    <p className="title text-center mb-10">
                                      {t("reservations.byDate.draftByDate.workersTooltip")}
                                    </p>
                                  </Col>
                                  <Col lg={6}>
                                    <p className="title text-center mb-10">
                                      {t("reservations.byDate.draftByDate.blockTooltip")}
                                    </p>
                                  </Col>
                                </Row>
                                {
                                  (loadingServices
                                    && <Row justify="center">
                                      <Spin className="cmt-spin" />
                                    </Row>
                                  )
                                  || (
                                    <Fragment>
                                      {reservationServices?.map(
                                        (service) => {
                                          return (
                                            <Row
                                              justify="space-between"
                                              key={service.id}
                                            >
                                              <Col lg={12}>
                                                <p>{service.name}</p>
                                              </Col>
                                              <Col lg={6}>
                                                <p className="text-center">
                                                  {service.total_patients}
                                                </p>
                                              </Col>
                                              <Col lg={6}>
                                                <p className="text-center">
                                                  {service.block}hs
                                                </p>
                                              </Col>
                                            </Row>
                                          );
                                        }
                                      )}
                                    </Fragment>
                                  )}
                              </Fragment>
                            }
                          >
                            <p className="mobile-title text-center">
                              {t("reservations.byDate.draftByDate.servicesTitle")}
                            </p>
                            <p
                              className="text-center mb-0"
                              style={{ cursor: "pointer" }}
                            >
                              {t("reservations.byDate.draftByDate.seeServicesButton")}
                            </p>
                          </Tooltip>
                        </Col>
                        {draftByDate && (
                          <Col lg={3} xs={12} className="table-body__item">
                            <p className="mobile-title text-center">
                              {t("reservations.byDate.draftByDate.creationTitle")}
                            </p>
                            {timeDiff(reservation.created_at, undefined, reservation.timezone)}
                          </Col>
                        )}
                        <Col
                          lg={draftByDate ? 3 : 2}
                          xs={12}
                          className="table-body__item button-wrapper"
                        >
                          {draftByDate ? (
                            <Link
                              to={{
                                pathname: `/reservas/${reservation.id}/editar`,
                                state: {
                                  from: location.pathname,
                                  search: location.search,
                                },
                              }}
                              style={{ width: "80%" }}
                              className="mr-lg-15"
                            >
                              <HasAccess
                                roles={['super_usuario', 'branch_office_manager', 'administracion']}
                                permissions='reservation-detail-edit'
                              >
                                <Button
                                  className={`cmt-button secondary outline ml-lg-10 ${!draftByDate && "mr-lg-15"
                                    }`}
                                  type="primary"
                                  size="small"
                                >
                                  Ver más
                                </Button>
                              </HasAccess>
                            </Link>
                          ) : (
                            <Link
                              to={{
                                pathname: `/reservas/${reservation.id}/ver`,
                                state: {
                                  from: location.pathname,
                                  search: location.search,
                                },
                              }}
                              style={{ width: "80%" }}
                              className="mr-lg-15"
                            >
                              <Button
                                className={`cmt-button secondary outline ml-lg-10 ${!draftByDate && "mr-lg-15"
                                  }`}
                                type="primary"
                                size="small"
                              >
                                Ver más
                              </Button>
                            </Link>
                          )}
                          {draftByDate && (
                            <HasAccess
                              roles={['super_usuario', 'branch_office_manager', 'administracion']}
                              permissions='reservation-delete'
                            >
                              <Button
                                className={`delete-icon-button ${reservation.has_admissions && "disabled"
                                  }`}
                                onClick={() => showModal(reservation)}
                                disabled={reservation.has_admissions}
                              >
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  viewBox="0 0 148.61 189.36"
                                >
                                  <g id="Capa_2" dataname="Capa 2">
                                    <g id="Capa_1-2" dataname="Capa 1">
                                      <path d="M47.16,21.25c0-3.94-.14-7.24,0-10.53C47.49,4.64,51.6.29,57.66.17q16.5-.33,33,0c6.37.11,10.48,4.42,10.78,10.79.15,3.28,0,6.58,0,10.4,11.53,0,22.48-.06,33.43,0,7.49,0,12.84,3.93,13.53,10a92.45,92.45,0,0,1,.07,10.16H.13c0-3.65-.34-7.14.08-10.54.69-5.58,5.89-9.6,12.18-9.65C23.71,21.19,35,21.25,47.16,21.25Zm46.89-.2c0-3.38,0-6.19,0-9C94,9,92.36,7.48,89.32,7.48c-10,0-20-.16-29.93.17-1.52,0-3.93,2.14-4.25,3.64-.67,3.1-.2,6.43-.2,9.76Z" />
                                      <path d="M15.42,54.5v4.63q0,58.15,0,116.31c0,10.25,4.24,13.91,16.09,13.91q42.55,0,85.09,0c12.36,0,16.25-3.36,16.25-14.11q0-57.93,0-115.88V54.5Z" />
                                    </g>
                                  </g>
                                </svg>
                              </Button>
                            </HasAccess>
                          )}
                        </Col>
                      </Row>
                    );
                  })}
                  <Modal
                    className="deletion-modal"
                    visible={modalVisible}
                    onCancel={closeModal}
                    centered={true}
                    closable={false}
                    footer={false}
                  >
                    {reservationToDelete && (
                      <Row justify="center" className="pb-10 pt-10">
                        <p className="text-center mb-10">
                          {t("reservations.byDate.draftByDate.modalDeleteText")}
                          <strong>{reservationToDelete.number}</strong>
                        </p>
                        <p className="text-center mb-30">
                          ¿Está seguro que desea eliminarla?
                        </p>
                        <Col lg={24} xs={24}>
                          <Row justify="center">
                            <Col className="mr-20">
                              <HasAccess
                                roles={['super_usuario', 'branch_office_manager', 'administracion']}
                                permissions='reservation-delete'
                              >
                                <Button
                                  className="cmt-button primary outline"
                                  type="primary"
                                  onClick={closeModal}
                                  size="large"
                                >
                                  No eliminar
                                </Button>
                              </HasAccess>
                            </Col>
                            <Col>
                              <HasAccess
                                roles={['super_usuario', 'branch_office_manager', 'administracion']}
                                permissions='reservation-delete'
                              >
                                <Button
                                  loading={draftReservations.isLoading}
                                  onClick={() =>
                                    doDeleteReservation(reservationToDelete.id)
                                  }
                                  classNarme="cmt-button primary"
                                  type="primary"
                                  size="large"
                                >
                                  {t("reservations.byDate.draftByDate.deleteReservationButton")}
                                </Button>
                              </HasAccess>
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    )}
                  </Modal>
                </Col>
                <Col lg={24} xs={24}>
                  {draftReservations.data && draftReservations.pagination && (
                    <Row className="pagination-wrapper mb-50">
                      <Col>
                        <Radio.Group className="cmt-pagination">
                          <Radio.Button
                            value="prev"
                            disabled={draftReservations.currentPage === 1}
                            onClick={loadMore}
                          >
                            Anterior
                          </Radio.Button>
                          <Radio.Button
                            value="next"
                            disabled={
                              draftReservations.data === null ||
                              draftReservations.pagination.total <
                              draftReservations.pagination.perPage
                            }
                            onClick={loadMore}
                          >
                            Siguiente
                          </Radio.Button>
                        </Radio.Group>
                      </Col>
                      <Col
                        className="ml-20"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      />
                    </Row>
                  )}
                </Col>
              </Fragment>
            ) : (
              <Empty
                description={
                  <span style={{ fontSize: 12 }}>
                    {t("reservations.byDate.draftByDate.emptyReservations")}
                  </span>
                }
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            )}
          </Row>
        </Spin>
      </Col>
    </Row>
  );
};

export default DraftReservation;